import MegaMenuSection from './MegaMenuSection';

export default MegaMenuSection;
